module.exports = __webpack_public_path__ + "img/alerts-3-mobile.209c04df.gif";